import { Box, Button, Divider, Flex, Stack, Text } from "@chakra-ui/react";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { errorNotifier, successNotifier } from "../..";
import FullPageLoader from "../full-page-loader";
import { paymentSuccess } from "../../pages/dashboard/tradingGroup/service";

  export const CheckoutForm = (props) => {
  
  const {selectedPlan, groupName, groupData, setShowPaymentForm} = props
  
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const gotoGroupChat = (groupData) => {
    navigate('/group', { state: { groupData: groupData } });
  }

  const paymentSuccessful = async (paymentId) => {
    const response = await paymentSuccess(paymentId)
    //console.log('paymentSuccessful: ', response?.data);
    if(response) {
      setLoading(false);
      setShowPaymentForm(false);
      successNotifier("Payment successful, you've been added to the group");

      gotoGroupChat(groupData)
      //navigate("/all-groups");
    } else {
      setLoading(false);
      setShowPaymentForm(false);
      errorNotifier("Something went wrong");
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const baseUrl = window.location.origin;
    const return_url_to = `${baseUrl}/groups`;

    const res = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: return_url_to,
      },
      redirect: "if_required",
    });
    console.log('resAwait: ', res);

    if (res?.error) {
      console.log('resErr: ', res?.error);
      setLoading(false);
    } else {
      console.log('resSuccess: ', res);
      paymentSuccessful(res?.paymentIntent?.id)
      // ... SEND to your API server to process payment intent
    }
  };
  return !elements ? (
    "Loading..."
  ) : (
    <form onSubmit={handleSubmit} my="10px">
      <Box my="20px" mb="30px">
        <Text fontSize="1.5em" fontWeight="300">
          You will be deducted{" "}
          <span style={{ fontWeight: "bold" }}>${selectedPlan?.price}</span>, to join{" "}
          {groupName} Group
        </Text>
        <Divider mt="10px" />
      </Box>
      <Text mb="10px">Please enter your card details to proceed</Text>
      <PaymentElement />
      {!stripe ? (
        <FullPageLoader h="200px" />
      ) : (
        <Stack direction={"row"} justify={"center"} align={"center"} my="25px">
          <button
            style={{
              color: "#fff",
              padding: "10px 35px",
              background: "#4346e1",
              borderRadius: "7px",
            }}
          >
            {loading ? "Loading..." : "Pay"}
          </button>
          <button
            style={{
              border: "1px solid #d3d3d3",
              padding: "10px 25px",
              borderRadius: "7px",
            }}
            bg="red"
            ml="10px"
            color="#fff"
            onClick={() => setShowPaymentForm(false)}
          >
            Cancel
          </button>
        </Stack>
      )}
    </form>
  );
};
